import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _QualityGarmentProperties, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SelectorUmeasurement } from "../../../../bpm/config/Componentes/SelectorUmeasurement";
import usePaginator from "../../../../theme/Component/usePaginator";

interface componentData {
    QualityGarment: any
}

export const QualityGarmentProperties = ({ QualityGarment }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityGarmentProperties)
    const paginador = usePaginator()

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar propiedad medible", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDQualityGarmentProperties', visible: true },
        { title: 'Nombre de la propiedad medible', property: 'Name', visible: true },
        { title: 'Unidad de Medida', property: 'UnitName', visible: true },
        { title: 'Valor Estandar', property: 'PropertieValue', visible: true },
    ];

    useEffect(() => {
        if (QualityGarment?.IDQualityGarment) {
            getLista();
        }
    }, [QualityGarment?.IDQualityGarment, paginador.page])

    const getLista = () => {
        const props = {
            IDQualityGarment: QualityGarment?.IDQualityGarment,
            State: 1
        }
        instance.getQualityGarmentPropertiesRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDQualityGarment: QualityGarment?.IDQualityGarment,
        });
        modal.open("Agregar propiedad medible");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar propiedad medible") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityGarmentProperties(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "IDMeasurementUnit",
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre de la propiedad medible</label>
                            <input type="text" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDMeasurementUnit') ? 'has-error' : ''}`} >Unida de Medida</label>
                            <SelectorUmeasurement idSelector={bean.IDMeasurementUnit} onChange={(e) => { setBean({ ...bean, IDMeasurementUnit: e }) }} titulo=" " />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('PropertieValue') ? 'has-error' : ''}`} >Valor de la Medida Estandar</label>
                            <input
                                type="number"
                                value={bean.PropertieValue}
                                onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, PropertieValue: value })
                                }}
                                className="form-control"
                            />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}